import { LoadFileFromLinkAction, loadFileList, setState } from '../actions';
import { call, put } from 'redux-saga/effects';
import api from '../../../../../../services/api';
import { message } from 'antd';

export function* loadFileFromLinkWorker(action: LoadFileFromLinkAction) {
  const { fileId } = action.payload;

  try {
    const resp = yield call(api.get, `/v1/company-library/${fileId}`);

    const { Data: file } = resp.data;
    if (!file) {
      message.error('File not found');
      yield put(loadFileList(true));
      return;
    }

    if (file.FolderID) {
      const parentsResp = yield call(
        api.get,
        `/v1/company-library/folders/listAllParents/${file.FolderID}`,
      );
      const { Data: parentFolders } = parentsResp.data;
      yield put(setState({ selectedFoldersStack: [...(parentFolders || []).reverse()] }));
    }

    yield put(
      setState({
        currentFolderID: file.FolderID,
        selectedFile: file,
        filters: {
          fileName: '',
          relatedEntities: [],
          relatedEntityTypes: [],
          sortOrder: null,
          memosOnly: false,
        },
      }),
    );
    yield put(loadFileList());
  } catch (err) {
    console.log('Failed to load file from link', err);
    message.error('Could not open the shared file. It may have been deleted or you lack access.');
    // Fall back to the normal library view so the page still renders.
    yield put(loadFileList(true));
  }
}
